export const TRIAL = 'TRIAL';

export const FREE = 'FREE';

export const PREMIER = 'PREMIER';

export const SEASONAL = 'SEASONAL';
